// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Cloud Costs API
 * API to get cloud cost information about Aura components and dev environments. Is used by the Aura Portal.
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface ApitypesUpsertEnvironmentsMetadataRequest
 */
export interface ApitypesUpsertEnvironmentsMetadataRequest {
  /**
   *
   * @type {string}
   * @memberof ApitypesUpsertEnvironmentsMetadataRequest
   */
  id?: string;
  /**
   *
   * @type {string}
   * @memberof ApitypesUpsertEnvironmentsMetadataRequest
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof ApitypesUpsertEnvironmentsMetadataRequest
   */
  owner?: string;
}

/**
 * Check if a given object implements the ApitypesUpsertEnvironmentsMetadataRequest interface.
 */
export function instanceOfApitypesUpsertEnvironmentsMetadataRequest(
  value: object,
): value is ApitypesUpsertEnvironmentsMetadataRequest {
  return true;
}

export function ApitypesUpsertEnvironmentsMetadataRequestFromJSON(
  json: any,
): ApitypesUpsertEnvironmentsMetadataRequest {
  return ApitypesUpsertEnvironmentsMetadataRequestFromJSONTyped(json, false);
}

export function ApitypesUpsertEnvironmentsMetadataRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ApitypesUpsertEnvironmentsMetadataRequest {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'] == null ? undefined : json['id'],
    name: json['name'] == null ? undefined : json['name'],
    owner: json['owner'] == null ? undefined : json['owner'],
  };
}

export function ApitypesUpsertEnvironmentsMetadataRequestToJSON(
  json: any,
): ApitypesUpsertEnvironmentsMetadataRequest {
  return ApitypesUpsertEnvironmentsMetadataRequestToJSONTyped(json, false);
}

export function ApitypesUpsertEnvironmentsMetadataRequestToJSONTyped(
  value?: ApitypesUpsertEnvironmentsMetadataRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    id: value['id'],
    name: value['name'],
    owner: value['owner'],
  };
}
